import {
  Badge,
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { QuestionAnswer as TicketIcon } from "@mui/icons-material";
import TicketsApiService from "../../../infrastructure/api/tickets";

const TicketDrawer = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadUnreadCount();
    // Refresh unread count every 30 seconds
    const interval = setInterval(loadUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadUnreadCount = async () => {
    try {
      const response = await TicketsApiService.getUnreadCount();
      if (response && response.isSuccess) {
        const count = Number(response.data) || 0;
        setUnreadCount(count > 0 ? count : 0);
      } else {
        setUnreadCount(0);
      }
    } catch (error) {
      console.error("Error loading unread tickets count:", error);
      setUnreadCount(0);
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(open);
  };

  const handleNavigateToTickets = () => {
    setOpen(false);
    navigate("/SLN/Tickets");
  };

  const handleCreateNewTicket = () => {
    setOpen(false);
    navigate("/SLN/Tickets");
  };

  return (
    <>
      <IconButton
        size="large"
        aria-label="تیکت‌ها"
        color="inherit"
        onClick={toggleDrawer(true)}
        sx={{ mr: 1 }}
      >
        <Badge badgeContent={unreadCount > 0 ? unreadCount : null} color="error">
          <TicketIcon />
        </Badge>
      </IconButton>

      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: 300, pt: 2 }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <Typography variant="h6" sx={{ px: 2, pb: 1 }}>
            پشتیبانی و تیکت‌ها
          </Typography>

          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={handleNavigateToTickets}>
                <ListItemIcon>
                  <Badge badgeContent={unreadCount > 0 ? unreadCount : null} color="error">
                    <TicketIcon />
                  </Badge>
                </ListItemIcon>
                <ListItemText
                  primary="تیکت‌های من"
                  secondary={
                    unreadCount > 0
                      ? `${unreadCount} پیام خوانده نشده`
                      : "مشاهده تمام تیکت‌ها"
                  }
                />
              </ListItemButton>
            </ListItem>
          </List>

          <Box sx={{ p: 2 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleCreateNewTicket}
              sx={{ mb: 1 }}
            >
              تیکت جدید
            </Button>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              نیاز به کمک دارید؟ تیکت خود را ایجاد کنید
            </Typography>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default TicketDrawer;